// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @14.07.2017 13:53:29
import { CUnmanagedResourceActivityHistory_abstract } from './../../abstract/SagaSchema/History/CUnmanagedResourceActivityHistory_abstract';
export class CUnmanagedResourceActivityHistory extends CUnmanagedResourceActivityHistory_abstract {}
